import { Box, Heading, Image, Skeleton, Text } from '@frontend/components';

const formatRuntime = (runtimeSeconds: number) => {
  if (!runtimeSeconds || runtimeSeconds <= 0) {
    return null;
  }

  const minutes = Math.floor(runtimeSeconds / 60);
  const seconds = String(runtimeSeconds % 60).padStart(2, '0');

  return `${minutes}:${seconds}`;
};

type SelectVideoButtonProps = {
  video: {
    duration: number;
    subtitle: string;
    thumbnail: string;
    title: string;
  };
  onClick: () => void;
};

const SelectVideoButton = ({ video, onClick }: SelectVideoButtonProps) => {
  const formattedRuntime = formatRuntime(video.duration);

  return (
    <Box
      as="button"
      onClick={onClick}
      alignItems="stretch"
      background="page.surface"
      border="1px solid"
      borderColor="separator.border"
      borderRadius="lg"
      display="flex"
      cursor="pointer"
      overflow="hidden"
      transition="all 0.2s ease"
      width="full"
      _hover={{ background: 'interaction.surfaceHover' }}
      _focus={{ background: 'interaction.surfaceActive', boxShadow: 'focus' }}
    >
      {video.thumbnail ? (
        <Box flexGrow={0} flexShrink={0} w={9}>
          <Image
            src={video.thumbnail}
            fallback={<Skeleton h="full" />}
            fit="cover"
            h="full"
            w="full"
          />
        </Box>
      ) : null}
      <Box textAlign="start" px={1.5} py={2}>
        <Heading as="h2" size="md">
          {video.title}
          {formattedRuntime ? ` (${formattedRuntime})` : ''}
        </Heading>
        <Text size="sm">{video.subtitle}</Text>
      </Box>
    </Box>
  );
};

export default SelectVideoButton;
